// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/DudeWheresMyShow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Portfolio styles */

div#project {
  display: flex;
  height: 23vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
}

#project:hover {
  filter: blur(4px);
}

#projTitle {
  display: hidden !important;
}

#portfolio-button {
  background-color: #db791a;
  color: white;
}

#portfolio-button:hover {
  background-color: #e99d51;
  color: white;
}

@keyframes pop-on-hover {
  50% {
    transform: scale(1.2);
  }
}

.pop-on-hover {
  display: inline-block;
  vertical-align: middle;
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
}

.pop-on-hover:hover,
.pop-on-hover:focus,
.pop-on-hover:active {
  animation-name: pop-on-hover;
  animation-duration: 0.3s;
  animation-timing-function: linear;
  animation-iteration-count: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Portfolio/Portfolio.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,aAAa;EACb,YAAY;EACZ,yDAA2D;EAC3D,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AASA;EACE;IAEE,qBAAqB;EACvB;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EAEtB,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;;;EAIE,4BAA4B;EAE5B,wBAAwB;EAExB,iCAAiC;EAEjC,4BAA4B;AAC9B","sourcesContent":["/* Portfolio styles */\n\ndiv#project {\n  display: flex;\n  height: 23vh;\n  background-image: url(../../../images/DudeWheresMyShow.png);\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n#project:hover {\n  filter: blur(4px);\n}\n\n#projTitle {\n  display: hidden !important;\n}\n\n#portfolio-button {\n  background-color: #db791a;\n  color: white;\n}\n\n#portfolio-button:hover {\n  background-color: #e99d51;\n  color: white;\n}\n\n@-webkit-keyframes pop-on-hover {\n  50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n  }\n}\n\n@keyframes pop-on-hover {\n  50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n  }\n}\n\n.pop-on-hover {\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-transform: perspective(1px) translateZ(0);\n  transform: perspective(1px) translateZ(0);\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0);\n}\n\n.pop-on-hover:hover,\n.pop-on-hover:focus,\n.pop-on-hover:active {\n  -webkit-animation-name: pop-on-hover;\n  animation-name: pop-on-hover;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
